import { BOW_BADGE } from '@components/vendorCard/constants';
import { StatusBadge } from '@tkww/orion-web-ds-feedback';
import { useAtomValue } from 'jotai';
import React from 'react';
import { vendorAwardsAtom } from '../../jotai/storefront/awards-summary';
import Styles from './bow-expanded-badge.scss';

export const BestOfWeddingsExpandedBadge = () => {
	const awards = useAtomValue(vendorAwardsAtom);
	const awardCount = awards.filter((a) => a.type === 'BOW').length;

	if (awardCount <= 0) {
		return null;
	}

	return (
		<span className={Styles.expandedBadge}>
			<StatusBadge icon={BOW_BADGE.icon} styleType={BOW_BADGE.type} size="md">
				{`${BOW_BADGE.label} (${awardCount}x)`}
			</StatusBadge>
		</span>
	);
};
